"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Provider = exports.Consumer = void 0;
exports.useTable = useTable;

var _react = require("react");

var TableContext = /*#__PURE__*/(0, _react.createContext)();
var Provider = TableContext.Provider,
    Consumer = TableContext.Consumer;
exports.Consumer = Consumer;
exports.Provider = Provider;

function useTable() {
  var context = (0, _react.useContext)(TableContext);
  return context;
}